import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import IncidentsList from './IncidentsList';

const Incidents = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Medio Ambiente', icon: 'icon-leaf' },
		{ to: '#', label: 'Parámetros Ambientales', icon: 'icon-thermometer-sun' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Incidentes' links={breadcrumbLinks} icon={'icon-database'} />
					<IncidentsList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Incidents;
